import React from 'react';
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import {PermissionEnum} from "../../../../../utils/enums/permission-enum.js";

const RoleModalDependencies = ({open, setOpen, permissionsDependency, conditionalPermissionsDependency, tablePermissions, rowPermission, resetLaneValue}) => {
    const confirm = (target) => {
        tablePermissions.current.api.forEachNode(row => {
            const {name, id} = row.data;
            if (target !== undefined &&  (conditionalPermissionsDependency[target].name === name)) {
                row.setSelected(true);
            }

            permissionsDependency.map(permission => {
                if (permission.name === name) {
                    if (permission.name === PermissionEnum.PASSAGE_LANE_ACCESS) {
                        resetLaneValue();
                    }

                    row.setSelected(true);
                }
            });
        })

        setOpen(false);
        rowPermission.setSelected(true);
    }

    const Title = () => {
        const {text} = rowPermission?.data;
        return <b>{text}<span style={{color: '#fbae1d'}}> é dependência de:</span></b>;
    }

    return (
        <Modal open={open} setOpen={setOpen} title={<Title/>} className={"w-8/12"} isCloseClick={false}>
            <Modal.Body className={"space-y-3 max-h-[calc(100vh-215px)] overflow-y-auto"}>
                {
                    conditionalPermissionsDependency.length > 0 && conditionalPermissionsDependency?.map((permission, key) => (
                        <section className={"p-4 border border-[#fbae1d] rounded-md relative space-y-2"} key={key}>
                            <h3 className={"absolute top-[-12px] px-1 bg-white !m-0"}>
                                Opção {key+1}
                            </h3>
                            <table>
                                <thead className={"bg-[#efefef] !text-[#2E3742] border border-[#dbdbdb] !text-[13px]"}>
                                <tr>
                                    <th className={"p-2 border-r border-r-[#dbdbdb]"} style={{width: '20%'}}>Grupo</th>
                                    <th className={"p-2"}>Permissão</th>
                                </tr>
                                </thead>
                                <tbody className={"border border-[#dbdbdb] border-t-0"}>
                                <tr key={permission.name}>
                                    <td className={"p-2 border-r border-r-[#dbdbdb]"}>{permission.group}</td>
                                    <td className={"p-2"}>
                                        {permission.text}
                                    </td>
                                </tr>
                                {
                                    permissionsDependency.map(permission => {
                                        return (
                                            <tr className={"border-t border-t-[#dbdbdb]"} key={permission.name}>
                                                <td className={"p-2 border-r border-r-[#dbdbdb]"}>{permission.group}</td>
                                                <td className={"p-2"}>
                                                    {permission.text}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                            <div className={"flex justify-end"}>
                                <Button onClick={() => confirm(key)}>
                                    Habilitar opção {key+1}
                                </Button>
                            </div>
                        </section>
                    ))
                }

                {
                    !conditionalPermissionsDependency.length &&
                    <section className={"space-y-2"}>
                        <table>
                            <thead className={"bg-[#efefef] text-[#2E3742]! border border-[#dbdbdb] text-[13px]!"}>
                            <tr>
                                <th className={"p-2 border-r border-r-[#dbdbdb]"} style={{width: '20%'}}>Grupo</th>
                                <th className={"p-2"}>Permissão</th>
                            </tr>
                            </thead>
                            <tbody className={"border border-[#dbdbdb] border-t-0"}>
                            {
                                permissionsDependency.map((permission, i) => {
                                    return (
                                        <tr className={i ? "border-t border-t-[#dbdbdb]" : ""} key={permission.name}>
                                            <td className={"p-2 border-r border-r-[#dbdbdb]"}>{permission.group}</td>
                                            <td className={"p-2"}>
                                                {permission.text}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </section>
                }
            </Modal.Body>
            {
                !conditionalPermissionsDependency.length &&
                <Modal.Footer>
                    <Button onClick={() => confirm()}>
                        Habilitar dependências
                    </Button>
                </Modal.Footer>
            }
        </Modal>
    );
};

export default RoleModalDependencies;